/**
 * @generated SignedSource<<ad50a4a6e6b85687496661f6555468b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReturningBuyerDeliveryOptionsView_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_buyer">;
  readonly " $fragmentType": "CheckoutReturningBuyerDeliveryOptionsView_buyer";
};
export type CheckoutReturningBuyerDeliveryOptionsView_buyer$key = {
  readonly " $data"?: CheckoutReturningBuyerDeliveryOptionsView_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReturningBuyerDeliveryOptionsView_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReturningBuyerDeliveryOptionsView_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9c447b8c17b5b773495c2215753c0906";

export default node;
